import React from "react";
import { strings } from "../../common/i18n";
import MatReactTableServer from "../../common/components/MaterialReactTableServer";
import useColumnsRows from "./useColumnsRows";
import ArchiveDialog from "./ArchiveDialog";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import { Button } from "@mui/material/";
import Tabs from "./Tabs";
/**
 * Planned audit Component
 */

export default () => {
    const {
        columns,
        closeArchiveDialog,
        currentStatus,
        currentRow,
        data,
        fetchAudits,
        loading,
        archiveDialog,
        onMultipleArchive,
        rowActions,
        tableInitialState,
        persistKey,
        selectionResetToken,
        enableRowSelection,
        getSubRows,
        page,
        pageSize,
        rowCount,
        setPage,
        setPageSize,
        setSearchQuery,
        setLoading
    } = useColumnsRows();

    const toolBarComponents = (selectedRowData) => (
        <Button
            size="small"
            variant="text"
            startIcon={<Inventory2OutlinedIcon fontSize="small" />}
            color={selectedRowData?.length ? "primary" : "inherit"}
            disabled={!selectedRowData?.length}
            onClick={() => onMultipleArchive(selectedRowData)}
        >
            {strings("archive")}
        </Button>
    );

    return (
        <>
            <Tabs />
            <MatReactTableServer
                columns={columns}
                data={data}
                loading={loading}
                rowActions={rowActions}
                rowSelection={true}
                toolBarComponents={toolBarComponents}
                noRowsMessage={strings("messages.noDraftAudits")}
                page={page}
                pageSize={pageSize}
                rowCount={rowCount}
                setPage={setPage}
                setPageSize={setPageSize}
                setSearchQuery={setSearchQuery}
                initialState={tableInitialState}
                persistKey={persistKey}
                selectionResetToken={selectionResetToken}
                enableRowSelection={enableRowSelection}
                muiCheckboxProps={({ row }) => ({
                    sx: { display: row.original.isGroup ? "none" : "inline-flex" }
                })}
                getSubRows={getSubRows}
            />
            <ArchiveDialog
                open={archiveDialog}
                onClose={closeArchiveDialog}
                row={currentRow}
                currentStatus={currentStatus}
                setLoading={setLoading}
                fetchAudits={fetchAudits}
            />
        </>
    );
};
